import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { authModule, application } from '@/store'
import Logo from '@/components/ui/Logo.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  setup(__props) {

const itensMenu = computed(() => authModule.activeMenus)

function temConteudoNovoItem(item: typeof authModule['activeMenus'][0]) {
	if (item.nome == 'Home') return application.temNovidades
	return false
}

return { __sfc: true,itensMenu, temConteudoNovoItem, authModule, Logo }
}

})